type Status = 'fulfilled' | 'rejected';

type SettledResponse<TStatus extends Status> = {
  status: TStatus;
  position: number;
};

type Fulfilled<T> = SettledResponse<'fulfilled'> & {
  value: T;
};
type Rejected<T extends Error> = SettledResponse<'rejected'> & {
  reason: T;
};

export function asSettled<T>(
  p: Promise<T>,
  position: number,
): Promise<Fulfilled<T> | Rejected<Error>> {
  return p.then(
    (value) => ({ value, status: 'fulfilled', position } as Fulfilled<T>),
    (reason) => ({ reason, status: 'rejected', position } as Rejected<Error>),
  );
}

export function isFulfilled<T>(
  response: Fulfilled<T> | Rejected<Error>,
): response is Fulfilled<T> {
  return response.status === 'fulfilled';
}

export function isRejected<T>(
  response: Fulfilled<T> | Rejected<Error>,
): response is Rejected<Error> {
  return response.status === 'rejected';
}
